// Utils
import { TIMES } from '../../../../../common/utils/timeUtil';

type ShouldFetchNotificationsParams = {
    isSocketConnected: boolean;
    notificationsFetchedTime?: number;
    notificationsErrorTime?: number;
    socketConnectionTime?: number;
    socketInterruptionTime?: number;
};

export const shouldFetchNotifications = ({
    isSocketConnected,
    notificationsFetchedTime = 0,
    notificationsErrorTime = 0,
    socketConnectionTime = 0,
    socketInterruptionTime = 0,
}: ShouldFetchNotificationsParams) => {
    if (!isSocketConnected) return false;

    // There wasn't an interruption, so no need to fetch
    if (!socketInterruptionTime) return false;

    const lastFetchAttempt = Math.max(notificationsFetchedTime, notificationsErrorTime);
    // Don't fetch if it's been less than a minute since the last fetch attempt
    const timeSinceLastFetch = Date.now() - lastFetchAttempt;
    if (timeSinceLastFetch < TIMES.MINUTE) return false;

    const timeSinceInterruption = Date.now() - socketInterruptionTime;

    const timeSinceLastSuccessfulFetch = Date.now() - notificationsFetchedTime;
    // If we've fetched since the last interruption, don't fetch
    if (timeSinceLastSuccessfulFetch < timeSinceInterruption) return false;

    const interruptionDuration = socketConnectionTime - socketInterruptionTime;

    // If the socket was interrupted for more than 2 minutes, fetch
    return interruptionDuration > 2 * TIMES.MINUTE;
};
